import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { BreakfastAndWifiDisclaimer } from './breakfast-wifi-disclaimer';
import { Messaging } from 'components/common/messaging';
import { SearchResultsReviews } from './search-results-reviews';

export const ListingCommonSection: React.FC = () => (
  <>
    <ErrorBoundary label="hotel.search.listing.messaging">
      <Messaging />
    </ErrorBoundary>
    <BreakfastAndWifiDisclaimer />
    <ErrorBoundary label="hotel.search.listing.reviews">
      <SearchResultsReviews />
    </ErrorBoundary>
  </>
);
ListingCommonSection.displayName = 'ListingCommonSection';
